var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { getUnifiedApiVersion } from "./ExpAPIVUnified.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "/workspaces/", parseError);
  }
  getExperiment(workspaceId, experimentId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experiments/${experimentId}?api-version=${getUnifiedApiVersion()}`;
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getExperimentRestResult(workspaceId, experimentId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experiments/${experimentId}?api-version=${getUnifiedApiVersion()}`;
      return yield this._get(address);
    });
  }
  createExperiment(workspaceId, createRequest) {
    return __async(this, null, function* () {
      const experimentId = createRequest.id || getNewGuid();
      const address = `${workspaceId}/experiments/${experimentId}??api-version=${getUnifiedApiVersion()}`;
      const result = yield this._put(createRequest, address);
      return result;
    });
  }
  editExperimentRestResult(workspaceId, experimentId, updateRequest) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experiments/${experimentId}?api-version=${getUnifiedApiVersion()}`;
      return yield this._put(updateRequest, address);
    });
  }
  operateOnExperiment(workspaceId, experimentId, operation) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experiments/${experimentId}:${operation.toString()}?api-version=${getUnifiedApiVersion()}`;
      return yield this._post(null, address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting the experiment.` })
], ExperimentResource.prototype, "getExperiment", 1);
__decorateClass([
  onError({ message: `An error occured while getting the experiment.` })
], ExperimentResource.prototype, "getExperimentRestResult", 1);
__decorateClass([
  onError({ message: `An error occured while creating the experiment.` })
], ExperimentResource.prototype, "createExperiment", 1);
__decorateClass([
  onError({ message: `An error occured while updating the experiment.` })
], ExperimentResource.prototype, "editExperimentRestResult", 1);
__decorateClass([
  onError({ message: `An error occured while operating experiment.` })
], ExperimentResource.prototype, "operateOnExperiment", 1);
ExperimentResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ExperimentResource);
var ExperimentOperation = /* @__PURE__ */ ((ExperimentOperation2) => {
  ExperimentOperation2["start"] = "start";
  ExperimentOperation2["stop"] = "stop";
  ExperimentOperation2["advance"] = "advance";
  return ExperimentOperation2;
})(ExperimentOperation || {});
const ExperimentResource$1 = new ExperimentResource();
export {
  ExperimentOperation,
  ExperimentResource,
  ExperimentResource$1 as default
};
//# sourceMappingURL=Experiment.resource.js.map
